<template>
    <section class="dock-filters">
        <custom-select
                v-show="breakpointDownMd"
                :options="filters"
                value-field="value"
                label-field="label"
                v-model="selectedFilter"
                @change="selectFilter"

        ></custom-select>
        <ul class="filters" v-show="!breakpointDownMd">
            <li v-for="filter in filters"><a :href="'#'+filter.value"
                                             data-barba-prevent
                                             @click.prevent="selectFilter(filter.value)"
                                             :class="initClass(filter.value)"><span>{{filter.label}}</span></a></li>
        </ul>
    </section>
</template>

<script>
    import Scrolling from "../libs/Scrolling"

    export default {
        props: {
            filters: {
                type: Array,
                required: true,
            }
        },
        data() {
            return {
                selectedFilter: null
            };
        },
        computed: {
            breakpointDownMd() {
                return this.$root.breakpointDownMd;
            },

        },
        methods: {
            selectFilter(filter) {
                if (breakpointDownMd){
                    Scrolling.scrollTo("#" + this.selectedFilter, "easeInOutExpo", 800, -Scrolling.hauteurMenuMobile - 2)
                }else{
                    Scrolling.scrollTo("#" + filter)
                }

                // Update window history
                let id = "#" + filter;
                if (window.history && window.history.pushState && id !== "#points-cles") {
                    history.pushState("", document.title, id);
                }
                if (window.history && window.history.pushState && id === "#points-cles") {
                    history.pushState("", document.title, " ");
                }

            },
            initClass(value) {
                if (value === this.filters[0].value) {
                    return value + " active"
                } else {
                    return value
                }
            }
        },
        created() {
            this.selectedFilter = this.filters[0].value
        },
        mounted() {
        }
    };
</script>
